<template>
    <div>
        <template v-if="showConfirmed">
            <h1 class="card-title h3">{{ $t('bookingService.alternative_dates.confirmed.title') }}</h1>
            <i18n path="bookingService.alternative_dates.confirmed.text" tag="p" class="card-text">
                <span slot="hotelname">{{ alternativeDatesData.arrangement.hotelname }}</span>
            </i18n>
            <div class="card-navigation">
            </div>
        </template>
        <template v-else-if="showDeclined">
            <h1 class="card-title h3">{{ $t('bookingService.alternative_dates.declined.title') }}</h1>
            <i18n path="bookingService.alternative_dates.declined.text" tag="p" class="card-text">
                <span slot="hotelname">{{ alternativeDatesData.arrangement.hotelname }}</span>
            </i18n>
            <p class="card-text">
                {{ $t('bookingService.alternative_dates.declined.text2') }}
            </p>
            <div class="card-navigation">
                <a :href="restartBookingUrl" class="btn btn-secondary" @click="$store.dispatch('reset')">
                    {{$t('voucherStatus.reset')}}
                </a>
            </div>
        </template>
        <template v-else-if="alternativeDatesData.arrangement">
            <h1 class="card-title h3">{{ $t('common.dear_guest') }}</h1>
            <i18n path="bookingService.alternative_dates.intro" tag="p" class="card-text">
                <span slot="duration">{{ alternativeDatesData.arrangement.productVariant.duration }}</span>
                <span slot="persons">{{ alternativeDatesData.arrangement.productVariant.persons }}</span>
                <span slot="roomtype">{{ alternativeDatesData.arrangement.productVariant.roomType }}</span>
                <span slot="catering">{{ alternativeDatesData.arrangement.productVariant.catering }}</span>
                <span
                    slot="additional_feature">{{
                        alternativeDatesData.arrangement.productVariant.additionalFeature
                    }}</span>
                <span slot="hotelname">{{ alternativeDatesData.arrangement.hotelname }}</span>
            </i18n>
            <h2 class="card-title h5">{{ $t('bookingService.alternative_dates.selection_title') }}</h2>
            <form ref="form" class="form avp-form" role="form" autocomplete="off"
                  @submit.prevent="sendBookingAlternativeSelectionForToken">
                <ul class="date-list">
                    <li v-for="(date, index) in alternativeDatesData.alternativeDates" :key="'date' + index">
                        <label :for="'date' + index"><input type="radio" v-model="selectedDate" :value="date"
                                                            :id="'date' + index" required/><span>{{
                                date
                            }}</span></label>
                    </li>
                </ul>
                <div class="align-items-center justify-content-center my-3">
                    <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
                        <button type="submit" class="btn btn-primary">
                            <span>{{ $t('bookingService.alternative_dates.send') }}</span>
                        </button>
                    </div>
                </div>
            </form>
            <div class="align-items-center justify-content-center my-3">
                <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
                    <form class="form avp-form" role="form" autocomplete="off"
                          @submit.prevent="sendBookingAlternativesDeclinedForToken">
                        <button type="submit" class="btn btn-secondary">
                            <span>{{ $t('bookingService.alternative_dates.no_suitable_date') }}</span>
                        </button>
                    </form>
                </div>
            </div>
            <i18n path="bookingServiceSuccess.supporting_text.common.customer_support.text" tag="p" class="card-text">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
        </template>
        <template v-else>
            <div class="card-navigation">
                <a href="/" class="btn btn-secondary" @click="$store.dispatch('reset')">
                    {{$t('voucherStatus.reset')}}
                </a>
            </div>
        </template>
    </div>
</template>

<script>
import CustomerServiceEmail from "../components/CustomerServiceEmail";
import CustomerServicePhone from "../components/CustomerServicePhone";
import {mapState} from 'vuex'

export default {
    name: 'BookingDetails',
    components: {CustomerServiceEmail, CustomerServicePhone},
    props: {
        token: String
    },
    data() {
        return {
            selectedDate: null,
            showConfirmed: false,
            showDeclined: false
        }
    },
    computed: {
        ...mapState(['alternativeDatesData']),
        fetchMethod() {
            if (this.token) {
                return this.fetchBookingAlternativesForToken;
            }
        },
        restartBookingUrl() {
            return "/booking?token=" + this.token;
        }
    },
    methods: {
        fetchBookingAlternativesForToken() {
            return this.$store.dispatch('fetchBookingAlternativesForToken', this.token);
        },
        sendBookingAlternativeSelectionForToken() {
            if (this.selectedDate) {
                this.$store.dispatch('sendBookingAlternativeSelectionForToken', {
                    token: this.token,
                    selectedDate: this.selectedDate
                });
                this.showConfirmed = true;
                this.showDeclined = false;
            } else {
                this.$store.commit('setErrors', [this.$t('bookingService.alternative_dates.required')]);
            }
        },
        sendBookingAlternativesDeclinedForToken() {
            this.$store.dispatch('declineBookingAlternativesForToken', this.token);
            this.showConfirmed = false;
            this.showDeclined = true;
        }
    },
    created() {
        this.fetchMethod();
    }
}
</script>

<style lang="scss">
@use "@/styles/_variables";

.avp-voucher-info {
    margin: 0 -#{variables.$padding} 1.25rem;
    padding: 1.25rem;
}

ul.date-list {
    list-style-position: outside;
    list-style-type: none;

    label {
        span {
            padding-left: 8px;
        }
    }
}

</style>
